import { getMonthBottomElements } from './get-month-bottom-elements';
import { getMonthFormattedTimeframes } from './get-month-formatted-timeframes';
import { getMonthTimeframes } from './get-month-timeframes';
import { getMonthTopElements } from './get-month-top-elements';
import { TTimelineColumns } from './timeline-timeframes';

// --------------------------------------------------
// --------------------- MONTH ----------------------
// --------------------------------------------------

export function setMonth(startYear: number, numberOfYears: number): TTimelineColumns {
  return {
    topWidth: 147,
    bottomWidth: 49,

    topElements: getMonthTopElements(startYear, numberOfYears),
    bottomElements: getMonthBottomElements(numberOfYears),
    timeframes: getMonthTimeframes(startYear, numberOfYears),
    formattedTimeframes: getMonthFormattedTimeframes(startYear, numberOfYears),
  };
}
